import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { PLANS_QUERY_KEYS } from "../queryKeys";
import { getCurrentPlan } from "../services/subscriptions";

export const useGetCurrentPlan = () => {
  const {
    i18n: { language },
  } = useTranslation();
  return useQuery({
    queryKey: [...PLANS_QUERY_KEYS.CURRENT_PLAN, language],
    queryFn: getCurrentPlan,
  });
};
